/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Compliance_Euai_SubInputs */

const en_landing_compliance_euai_sub = /** @type {(inputs: Landing_Compliance_Euai_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transparency features`)
};

const de_landing_compliance_euai_sub = /** @type {(inputs: Landing_Compliance_Euai_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transparenzfunktionen`)
};

const fr_landing_compliance_euai_sub = /** @type {(inputs: Landing_Compliance_Euai_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fonctions de transparence`)
};

const es_landing_compliance_euai_sub = /** @type {(inputs: Landing_Compliance_Euai_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funciones de transparencia`)
};

const it_landing_compliance_euai_sub = /** @type {(inputs: Landing_Compliance_Euai_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funzionalità di trasparenza`)
};

const nl_landing_compliance_euai_sub = /** @type {(inputs: Landing_Compliance_Euai_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transparantiefuncties`)
};

const pl_landing_compliance_euai_sub = /** @type {(inputs: Landing_Compliance_Euai_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funkcje przejrzystości`)
};

const fi_landing_compliance_euai_sub = /** @type {(inputs: Landing_Compliance_Euai_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Läpinäkyvyysominaisuudet`)
};

const da_landing_compliance_euai_sub = /** @type {(inputs: Landing_Compliance_Euai_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gennemsigtighedsfunktioner`)
};

const sv_landing_compliance_euai_sub = /** @type {(inputs: Landing_Compliance_Euai_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transparensfunktioner`)
};

/**
* | output |
* | --- |
* | "Transparency features" |
*
* @param {Landing_Compliance_Euai_SubInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_compliance_euai_sub = /** @type {((inputs?: Landing_Compliance_Euai_SubInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Compliance_Euai_SubInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_compliance_euai_sub(inputs)
	if (locale === "fr") return fr_landing_compliance_euai_sub(inputs)
	if (locale === "es") return es_landing_compliance_euai_sub(inputs)
	if (locale === "it") return it_landing_compliance_euai_sub(inputs)
	if (locale === "nl") return nl_landing_compliance_euai_sub(inputs)
	if (locale === "pl") return pl_landing_compliance_euai_sub(inputs)
	if (locale === "fi") return fi_landing_compliance_euai_sub(inputs)
	if (locale === "da") return da_landing_compliance_euai_sub(inputs)
	if (locale === "sv") return sv_landing_compliance_euai_sub(inputs)
	return en_landing_compliance_euai_sub(inputs)
});